import React, { useEffect, useState } from 'react';

// Vorschau eines lokal gesicherten Fotos (Blob aus dem Entwurf). Die Adresse entsteht im Effekt und wird
// dort auch wieder freigegeben — so überlebt sie doppeltes Ein-/Aushängen (React StrictMode, Neuaufbau
// beim Theme-Wechsel), ohne dass das Bild bricht.
const FotoVorschau: React.FC<{ blob: Blob; groesse?: number }> = ({ blob, groesse = 72 }) => {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    const u = URL.createObjectURL(blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [blob]);
  return (
    <span className="inline-block shrink-0 overflow-hidden" style={{ width: groesse, height: groesse, borderRadius: 16, background: 'var(--fill2)', boxShadow: 'inset 0 0 0 1px var(--line)' }}>
      {url && <img src={url} alt="Foto" className="h-full w-full object-cover" />}
    </span>
  );
};

export default FotoVorschau;
